<script setup lang="ts">
type Link = {
  title: string
  href?: string
  icon?: any
  external?: boolean
  onClick?: () => void
}

type Props = {
  links: Link[]
}

defineProps<Props>()
</script>

<template>
  <ul class="app-list-links">
    <li v-for="(link, index) in links" :key="index">
      <button v-if="link.onClick" @click="link.onClick">
        <span v-if="link.icon" class="app-list-links__icon">
          <component :is="link.icon" />
        </span>

        <span class="app-list-links__title h4">{{ link.title }}</span>

        <IconChevronDown class="app-list-links__arrow" />
      </button>

      <NuxtLink v-else :to="link.href" :external="link.external">
        <span v-if="link.icon" class="app-list-links__icon">
          <component :is="link.icon" />
        </span>

        <span class="app-list-links__title h4">{{ link.title }}</span>

        <IconChevronDown class="app-list-links__arrow" />
      </NuxtLink>
    </li>
  </ul>
</template>

<style lang="scss">
@import '@boats/ui/styles/config';

.app-list-links {
  margin: 0;
  padding: 0;
  list-style: none;
  color: $black;

  li {
    border-bottom: 1px solid $black;

    &:first-child {
      border-top: 1px solid $black;
    }
  }

  a,
  button {
    display: flex;
    align-items: center;
    width: 100%;
    min-height: 3.25rem;
    padding-top: 0.75rem;
    padding-bottom: 0.75rem;
    @include transition('color');

    &:hover {
      color: $tint-red-hover;
      text-decoration: none;
    }
  }

  @include media-breakpoint-up(md) {
    a,
    button {
      min-height: 5rem;
    }
  }
}

.app-list-links__icon {
  margin-right: 0.75rem;

  svg {
    width: 1.5rem;
    height: 1.5rem;
  }

  @include media-breakpoint-up(md) {
    margin-right: 1.5rem;

    svg {
      width: 2rem;
      height: 2rem;
    }
  }
}

.app-list-links__title {
  display: block;
  margin-right: auto;
  color: inherit;
}

.app-list-links__arrow {
  width: 1rem;
  height: 1rem;
  margin-left: 1.25rem;
  transform: rotate(-90deg);

  @include media-breakpoint-up(md) {
    width: 1.5rem;
    height: 1.5rem;
  }
}
</style>
